import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography } from '@mui/material';
import React, { useEffect, forwardRef } from 'react';
import { Image } from '../../../components';
import { useIsDesktop } from '../../../utils/mediaQueries';
import { useSidebarContext } from '../../contexts/Sidebar';
import useMediaQuery from '../../hooks/useMediaQuery';
import { breakpoints } from '../../utils/mediaQueries';
import Menu from './Menu';
import MenuItem from './MenuItem';
import { StyledSidebar, StyledSidebarNavigation, StyledSidebarBackdrop } from './Sidebar.styles';
import SubMenu from './SubMenu';
const Sidebar = forwardRef(({ children, width, breakpoint, customBreakpoint, transitionDuration, backdropAriaLabel, ...restProps }, ref) => {
    const alwaysBroken = breakpoint === 'always';
    const regularBreakpoint = !alwaysBroken ? breakpoint : undefined;
    const matchesBreakpoint = useMediaQuery(customBreakpoint ?? (regularBreakpoint ? breakpoints[regularBreakpoint] : undefined));
    const broken = alwaysBroken || matchesBreakpoint;
    const { updateSidebarState, width: widthContext, broken: brokenContext, toggled: toggledContext, transitionDuration: transitionDurationContext, } = useSidebarContext();
    const resolvedWidth = width || (broken ? `${window?.innerWidth - 40}px` : '120px');
    const handleBackdropClick = () => {
        updateSidebarState({ toggled: false });
    };
    useEffect(() => {
        updateSidebarState({ width: resolvedWidth, broken });
        if (!broken && toggledContext === true) {
            updateSidebarState({ toggled: false });
        }
    }, [resolvedWidth, broken, updateSidebarState, toggledContext]);
    useEffect(() => {
        updateSidebarState({ transitionDuration, toggled: false });
    }, [transitionDuration, updateSidebarState]);
    const isDesktop = useIsDesktop();
    return (_jsxs(StyledSidebar, { ref: ref, width: widthContext, broken: brokenContext, toggled: toggledContext, transitionDuration: transitionDurationContext ?? 300, children: [_jsxs(StyledSidebarNavigation, { ...restProps, children: [!isDesktop && (_jsxs(Box, { sx: {
                            display: 'flex',
                            padding: '0.5rem 1rem 0 2rem',
                            alignItems: 'center',
                            flex: '0 0 auto',
                        }, children: [_jsx(Box, { sx: { borderRight: 'solid 2px #051D33' }, children: _jsx(Image, { src: '/assets/images/moneris-logo.svg' }) }), _jsx(Box, { sx: { padding: '14px 0 0 1rem' }, children: _jsx(Typography, { variant: 'body1', sx: { color: 'secondary.dark' }, children: "Insights*" }) }), _jsx(Box, { sx: {
                                    display: 'flex',
                                    paddingTop: '15px',
                                    justifyContent: 'flex-end',
                                    width: '100%',
                                }, children: _jsx(IconButton, { size: 'small', onClick: handleBackdropClick, children: _jsx(Image, { src: '/assets/images/x.svg' }) }) })] })), children] }), brokenContext && toggledContext && (_jsx(StyledSidebarBackdrop, { role: 'button', tabIndex: 0, "aria-label": backdropAriaLabel, onClick: handleBackdropClick, onKeyPress: handleBackdropClick }))] }));
});
Sidebar.displayName = 'Sidebar';
Sidebar.defaultProps = {
    transitionDuration: 300,
    backdropAriaLabel: 'backdrop',
};
export default { Sidebar, Menu, MenuItem, SubMenu };
